import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/StudyBudgets/language/en";
import loader from "@/views/shared/loading/Loading.vue";
import Editor from '@tinymce/tinymce-vue';
import Axios from 'axios';
import alert from "@/views/shared/notify/Alert.vue";
import SelectFile from "@/components/layout/shared/generic/common/SelectFile.vue";

export default {
    name: "new-studybudgets",
 
    components: {
        Datepicker,
        'editor': Editor,
        loader,
        alert,
        SelectFile
    },
    data() {
        return {
            loading: true,
            itemloading:false,
            budgetHead: [],
            budgetItem:[],
            leftArr:[],
            lang:[],
            formObj:{
                has_attachment:false,
                upload_file:'',
                template_status:'Active'
            },
            dom_array: [],
            nameerror:'',       
        }
    },
    mounted() {
        this.getBudgetHead();
       // this.getBudgetItem();
        this.checkPermisson();
        this.lang = lang;
        this.formObj.template_name = '';
        this.formObj.currency_name = '';
        this.formObj.currency = '';
        this.formObj.years = '';
        this.formObj.has_attachment = false;
        this.formObj.upload_file = '';
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        
        getBudgetHead() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/getBudgetHead',{params:{'AllHead':'AllHead'}}).then(function(response){
                self.budgetHead = response.data;
                self.loading = false;
            })
        },
        checkPermisson() {
            const self = this;
            //self.loading = false;
        },
        
        moveData(side){
            const self = this;
            var id = [];
            $(':checkbox:checked').each(function(i){
                if(id == ''){
                   id[i]=$(this).val();
                }else{
                   id[i]=$(this).val();
                }
             
            });
            let arr={};
            for(let i = 0; i < id.length; i++)
            {
                let items = id[i].split("_");
                let head_id = items[0];
                let item_id = items[1];
                let item_name = items[2];
                let narration = items[3];
                let is_changeable = items[4];
                arr = {'head_id':head_id, 'item_id':item_id, 'item_name':item_name, 'narration':narration, 'is_changeable':is_changeable};
                self.leftArr.push(arr);
            }
           
            if(self.leftArr.length > 0 && self.nameerror == ''){
                if(self.formObj.template_name !='' && self.formObj.currency !='' && self.formObj.years !=''){
                    let left_array = {
                                        'side':side,
                                        'name':self.formObj.template_name,
                                        'right_arr':self.leftArr,
                                        'form':{
                                            'template_id':self.formObj.template_id,
                                            'template_name':self.formObj.template_name,
                                            'currency_name':self.formObj.currency_name,
                                            'currency':self.formObj.currency,
                                            'years':self.formObj.years,
                                            'template_status':self.formObj.template_status,
                                            'name': self.formObj.template_name,
                                            'upload_file': self.formObj.upload_file,
                                            'upload_file_name': self.formObj.upload_file_name,
                                            'has_attachment': self.formObj.has_attachment,
                                        }
                                    };

                self.itemloading = true;
                Axios.post('api/modules/moveright', left_array).then(function(response){
                   
                    self.formObj.template_id = response.data.templates[0].id;
                    self.formObj.template_name = response.data.templates[0].name;
                    self.formObj.currency_name = response.data.templates[0].currency_name;
                    self.formObj.currency = response.data.templates[0].currency_multiplier;
                    self.formObj.years = response.data.templates[0].template_year;
                    self.formObj.has_attachment = response.data.templates[0].has_attachment;
                   // this.formObj.upload_file = '';
                    let id = self.formObj.template_id;
                    let strdata = btoa(id);
                    localStorage.setItem('budgetTempId', strdata);
                    self.$router.push('/modules/studybudgets/edit/pending');
                    
                    }).catch(error =>{
                        let allerror = document.getElementsByClassName('error');
                        for(let i = 0; i < allerror.length; i++)
                        {
                            allerror[i].innerHTML = '';
                        }
                        let err = localStorage.getItem('Errors');
                        let err_msg = (JSON.parse(err));
                        let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                        Object.keys(err_msg2 || {}).forEach((key) => {
                            let errorval = err_msg2[key];
                           
                            let error_el = document.getElementById(key+"_error");
                                error_el.innerHTML = errorval
                        });
                        localStorage.removeItem('Errors');
                    })
                }else{
                   
                    self.$refs.notifyMsg.showAlert('Error','Please provide Value for each filed to create a new template.');
                }
                
            }else{
                self.$refs.notifyMsg.showAlert('Error','Please select at least one option from budget head\n OR Check Template Name');
               
            }            
        },
        checkall(headid){
            if($("#head_"+headid).is(":checked"))
            {
                let elName = document.getElementsByClassName("check-all_"+headid);
                for(let i = 0; i < elName.length; i++)
                {
                    document.getElementById(elName[i].id).checked = true;
                }
            }else{
                let elName = document.getElementsByClassName("check-all_"+headid);
                for(let i = 0; i < elName.length; i++)
                {
                    document.getElementById(elName[i].id).checked = false;
                }
            }
        },
        checktemplatename(event){
            const self = this;
            self.nameerror = '';
            if(event.target.value != '' && event.target.value != ' '){
                Axios.post('api/modules/studybudgets/validatename', {'template_name':event.target.value}).then(function(response){
                    if(response.data.message == 'Duplicate'){
                        self.nameerror = "This template already exist";
                    }else{
                        self.nameerror = '';
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        checkSubhead(){
            const self = this;
            const hasLeftChecked = $('.leftCheckBox[class*="check-all_"]:checked').length > 0;
            if (!hasLeftChecked) {
                self.$refs.notifyMsg.showAlert('Error', 'Please select at least one head');
                return false;
            }
            return true;
        }  
    }

}